





























































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import WorkLog from '../../../store/entities/wm/worklog'
import ComboboxItem from '@/store/entities/combobox-item'
import CreateLogMember from './create-log-member.vue'
import serachmember from '@/store/entities/wm/searchworklogmember'
@Component({
  components: { CreateLogMember }
})
export default class CreateWorkLog extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean
  worklogModal: WorkLog = new WorkLog()
  createmember: boolean = false
  serachmember: serachmember = new serachmember()
  //项目GUID
  projectId: string
  logmembers: Array<any> = []
  oldlogmembers: Array<any> = []
  usermemberdata: Array<any> = []
  get roles() {
    return this.$store.state.user.roles
  }
  save() {
    let mempeoplr = ''
    for (let i = 0; i < this.logmembers.length; i++) {
      mempeoplr += this.logmembers[i].userId + ',' // 获取从第一个字符开始的子字符串，即去掉开头的 "L"
    }
    this.worklogModal.invitelogid = mempeoplr
    ;(this.$refs.LogForm as any).validate(async (valid: boolean) => {
      var day = (new Date(this.worklogModal.endDate).getTime() - new Date(this.worklogModal.startDate).getTime()) / (1000 * 60 * 60 * 24)
      if (day < 0) {
        this.$Message.error(this.L('WM.ErrorDuration'))
        return
      }
      if (valid) {
        await this.$store.dispatch({
          type: 'worklog/create',
          data: this.worklogModal
        })
        this.logmembers = []
        this.oldlogmembers = []
        this.$store.commit('worklog/setmemberliststring', this.logmembers)
        this.$store.commit('worklog/setoldmemberliststring', this.oldlogmembers)
        ;(this.$refs.LogForm as any).resetFields()
        this.$Message.success(this.L('SavedSuccess'))
        this.$emit('save-success')
        this.$emit('input', false)
      }
    })
  }
  //删除标签
  removeMember(index) {
    this.logmembers.splice(index, 1)
  }
  get projectIdList(): Array<ComboboxItem> {
    return this.$store.state.worklog.projectItem
  }
  async addmember() {
    this.usermemberdata = []
    if (!this.worklogModal.projectId) {
      this.$message({
        message: '请选择具体的项目',
        type: 'warning'
      })
      return
    }
    this.$store.commit('worklog/setmemberliststring', this.logmembers)
    this.$store.commit('worklog/setoldmemberliststring', this.oldlogmembers)
    this.serachmember.Id = this.projectId
    this.$store.commit('worklog/SearchWorkMember', this.serachmember)
    this.createmember = true
  }
  async handleClose() {
    this.logmembers = this.$store.state.worklog.memberlist
    this.oldlogmembers = this.$store.state.worklog.memberlist
  }
  async handleCancel() {
    this.logmembers = this.$store.state.worklog.oldmemberlist
  }
  projectIdChange(value) {
    let item = this.projectIdList.find((c) => c.value == value)
    this.worklogModal.projectName = item.displayText
    this.worklogModal.projectId = item.value
    //项目GUID
    this.projectId = item.value
  }
  startChange(value) {
    this.worklogModal.startDate = value
  }
  endChange(value) {
    this.worklogModal.endDate = value
  }
  clear() {
    this.logmembers = []
    this.oldlogmembers = []
    this.$emit('input', false)
  }
  cancel() {
    this.logmembers = []
    this.oldlogmembers = []
    ;(this.$refs.LogForm as any).resetFields()
    this.$emit('input', false)
  }
  created() {
    // this.worklogModal = Util.extend(true, {}, this.$store.state.worklog.editWorkLog)
    // this.worklogModal.startDate = this.worklogModal.startDate
    // this.worklogModal.endDate = this.worklogModal.endDate
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.logmembers = []
      this.oldlogmembers = []
      this.$emit('input', value)
    } else {
      await this.$store.dispatch({
        type: 'worklog/getSelectData'
      })
      this.worklogModal = Util.extend(true, {}, this.$store.state.worklog.editWorkLog)
      this.projectId = this.worklogModal.projectId
    }
  }
  workLogRule = {
    startDate: [{ required: true, message: this.L('PleaseSelect', undefined, this.L('WM.LogSETime')), trigger: 'change', pattern: /.+/ }],
    endDate: [{ required: true, message: this.L('PleaseSelect', undefined, this.L('WM.LogSETime')), trigger: 'change', pattern: /.+/ }],
    projectId: [{ required: true, message: this.L('PleaseSelect', undefined, this.L('WM.ProjectName')), trigger: 'change' }],
    txtBody: [{ required: true, message: this.L('PleaseInput', undefined, this.L('WM.LogContent')), trigger: 'blur' }]
  }
}
